'use es6';

import { fromJS } from 'immutable';
import { THEME } from 'reporting-data/tsTypes/visualization/colors';
import { Metrics } from '../../monitoring/Metrics';
import { defaultLegendOptions } from './legendOptions';
import { defaultAreaSeriesOptions } from './series/areaSeriesOptions';
import { defaultAreaRangeSeriesOptions } from './series/arearangeSeriesOptions';
import { defaultBarSeriesOptions } from './series/barSeriesOptions';
import { defaultColumnSeriesOptions } from './series/columnSeriesOptions';
import { defaultLineSeriesOptions } from './series/lineSeriesOptions';
import { defaultPieSeriesOptions } from './series/pieSeriesOptions';
import { defaultScatterSeriesOptions } from './series/scatterSeriesOptions';
import { defaultWaterfallSeriesOptions } from './series/waterfallSeriesOptions';
import { defaultSeriesOptions } from './series/seriesOptions';
import { defaultTooltipOptions } from './tooltipOptions';

/**
 * Static default color options (hex codes)
 *
 * @internal
 * @deprecated Use `getDefaultOptions({ reportingThemes })` instead for tokenized theme support.
 * This static array is kept for backward compatibility but does not support dynamic theming.
 *
 * @type {string[]}
 */
export const getLegacyDefaultColorOptions = calledFrom => {
  Metrics.counter('getLegacyDefaultColorOptions', {
    calledFrom
  }).increment();
  return ['#fea58e', '#51d3d9', '#bda9ea', '#f5c78e', '#ea90b1', '#81c1fd', '#a4d398', '#c3705c', '#009ca2', '#9784c2', '#bb915b', '#b05c7d', '#468cc4', '#6b9a5b'];
};

/**
 * Get default options with optional tokenized theme support
 */
export const getDefaultOptions = ({
  reportingThemes
} = {}) => {
  const tokenizedColors = reportingThemes === null || reportingThemes === void 0 ? void 0 : reportingThemes.get(THEME.MULTI);
  const colors = tokenizedColors !== null && tokenizedColors !== void 0 ? tokenizedColors : getLegacyDefaultColorOptions('getDefaultOptions');
  return fromJS({
    chart: {
      animation: false,
      spacingRight: 50,
      style: {
        fontFamily: 'inherit',
        color: 'var(--trellis-color-text-core-default)'
      },
      type: 'column',
      backgroundColor: 'rgba(0,0,0,0)'
    },
    title: {
      text: null
    },
    colors,
    plotOptions: {
      series: defaultSeriesOptions,
      area: defaultAreaSeriesOptions,
      arearange: defaultAreaRangeSeriesOptions,
      bar: defaultBarSeriesOptions,
      column: defaultColumnSeriesOptions,
      line: defaultLineSeriesOptions,
      pie: defaultPieSeriesOptions,
      scatter: defaultScatterSeriesOptions,
      waterfall: defaultWaterfallSeriesOptions
    },
    // dont edit these, going to make default axis settings for each type
    xAxis: [{}],
    yAxis: [{}],
    legend: defaultLegendOptions,
    tooltip: defaultTooltipOptions,
    credits: {
      enabled: false
    }
  });
};